import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';

// sample page routing
const Dashboard = Loadable(lazy(() => import('views/welcome/dashboard')));
const Settings = Loadable(lazy(() => import('views/welcome/settings')));
const Notifications = Loadable(lazy(() => import('views/welcome/notifications')));
const Payments = Loadable(lazy(() => import('views/welcome/payments')));
const ContactUs = Loadable(lazy(() => import('views/resources/contact-us')));
const Enviago = Loadable(lazy(() => import('views/enviago')));

// ===========================|| MAIN ROUTING ||=========================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <Navigate to="/dashboard" />
        },
        {
            path: '/dashboard',
            element: <Dashboard />
        },
        {
            path: '/payments',
            element: <Payments />
        },
        {
            path: '/settings',
            element: <Settings />
        },
        {
            path: '/notifications',
            element: <Notifications />
        },
        {
            path: '/contact-us',
            element: <ContactUs />
        },
        {
            path: '/enviago',
            element: <Enviago />
        }
    ]
};

export default MainRoutes;
